import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { SignOut, Compass } from "@phosphor-icons/react";
import { Link, useLocation } from "react-router-dom";

export default function Layout({ children, nav = [] }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
              <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center text-white">
                <Compass size={18} weight="duotone" />
              </div>
              <div className="font-display font-black tracking-tight">FieldOps</div>
            </Link>
            <nav className="hidden md:flex items-center gap-1">
              {nav.map((n) => {
                const active = location.pathname === n.to;
                return (
                  <Link
                    key={n.to}
                    to={n.to}
                    data-testid={`nav-${n.key}`}
                    className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${active ? "bg-slate-900 text-white" : "text-slate-600 hover:text-slate-900 hover:bg-slate-100"}`}
                  >
                    {n.label}
                  </Link>
                );
              })}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-semibold" data-testid="user-name">{user?.name}</div>
              <div className="overline text-[10px]">{user?.role}</div>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={logout}
              data-testid="logout-button"
              className="rounded-full"
            >
              <SignOut size={16} className="mr-1" /> Sign out
            </Button>
          </div>
        </div>
        {/* Mobile nav */}
        <div className="md:hidden border-t border-slate-100 px-2 py-2 flex gap-1 overflow-x-auto">
          {nav.map((n) => {
            const active = location.pathname === n.to;
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`mnav-${n.key}`}
                className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap ${active ? "bg-slate-900 text-white" : "text-slate-600 bg-slate-100"}`}
              >
                {n.label}
              </Link>
            );
          })}
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-8">{children}</main>
    </div>
  );
}
